// extracted by mini-css-extract-plugin
export default {"header":"YC5UcoeK6OPPeZDgb8EL","tagContainer":"oU98dYLZOea83v39T71x"};